var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'player-' + _vm.youtubeId,attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.youtubeId}})}
var staticRenderFns = []

export { render, staticRenderFns }